// Stand-ins for the two Twenty SDK modules the desk's page file imports, so the same page file runs outside the CRM.
// useColorScheme reports the real scheme (the CRM's version does too), driven by the Light/Dark/System switch.
import { useResolvedScheme } from '../client/theme';

export const defineFrontComponent = <T,>(config: T): T => config;
export const useColorScheme = (): 'light' | 'dark' => useResolvedScheme();
